import { GetCodeListResponse } from '../../../commons/kymw02/api-services/get-code-list.service';
import { GetMarkGroupListResponse } from '../kymw1500/api-services/get-mark-group-list.service';

/**
 * アイコン登録画面の値を管理するクラス
 *
 * @export KYMW1506Model
 * @class KYMW1506Model
 */
export class KYMW1506Model {
  /** アイコンコード */
  public iconCode: string = '';
  /** コード指定 */
  public iconCodeEntry: boolean = false;
  /** アイコン名 */
  public iconName: string = '';
  /** アイコングループ */
  public iconGroup: string = '';
  /** アイコン区分 */
  public iconDiv: string = '';
  /** 配置区分 */
  public arrangeDiv: string = '';
  /** アイコン説明 */
  public iconExplain: string = '';

  /** マークグループリスト */
  public markGroupList: GetMarkGroupListResponse = [];

  /** 出力区分 */
  /** 商品マスタ */
  public category: boolean = false;
  /** ウィークリー */
  public weekly: boolean = false;
  /** デイリー */
  public daily: boolean = false;
  /** 見切り品 */
  public logistics: boolean = false;
  /** 注文確認画面表示対象フラグ */
  public order: boolean = false;

  /** 使用開始 指定無し */
  public notDesignateStart = true;

  /** 使用開始 受注コード */
  public startOrderCodeInit: string = <string>'';
  public startOrderCode: string = <string>'';
  public startOrderCodeEnabled = false;

  /** 使用開始　配達企画回 */
  public startDelivCatalogIdDisabled = true;

  /** 使用終了 指定無し */
  public notDesignateEnd = true;

  /** 使用終了 受注コード */
  public endOrderCodeInit: string = <string>'';
  public endOrderCode: string = <string>'';
  public endOrderCodeEnabled = false;

  /** 使用終了　配達企画回 */
  public endDelivCatalogIdDisabled = true;

  /** アイコンファイル(通常) */
  public imageFileNormal: File = null;
  public imageFileNameNormal: string = '';
  public imageFileUrlNormal: string = '';
  /** アイコンファイル(大) */
  public imageFileBig: File = null;
  public imageFileNameBig: string = '';
  public imageFileUrlBig: string = '';
  /** アイコンファイル(モバイル) */
  public imageFileMobile: File = null;
  public imageFileNameMobile: string = '';
  public imageFileUrlMobile: string = '';

  /** アイコン代替テキスト */
  public iconAlternativeText: string = '';

  // 出力区分
  // 右から1文字目：商品マスタ、2文字目：ウィークリー、3文字目：デイリー、
  // 4文字目：スポット、5文字目：見切り品、6文字目：注文確認画面表示対象フラグ、
  // 7文字目：予備、8文字目：予備
  // 0：表示しない、1：表示する
  // ※ 以下パラメータについては値として返却しているが、フロントエンド側での使用を想定していない
  // 4文字目：スポット
  // 7文字目：予備
  // 8文字目：予備
  private outputDivMap = {
    1: 'category',
    2: 'weekly',
    3: 'daily',
    4: null,
    5: 'logistics',
    6: 'order',
    7: null,
    8: null,
  }

  /**
   * マークグループリストを更新する
   *
   * @param serverData マークグループリストのサーバ取得データ
   */
  public updateMarkGroupList(serverData: any) {
    this.markGroupList = serverData;
  }

  /**
   * チェックボックスの出力区分を更新API用の00100010といった形式で取得する
   */
  public getOutputDiv(): string {
    let outputDiv = '';
    for (var i = 0; i < Object.keys(this.outputDivMap).length; i++){
      if (this.outputDivMap[i+1] !== null && this[this.outputDivMap[i+1]]) {
        outputDiv = '1' + outputDiv;
      } else {
        outputDiv = '0' + outputDiv;
      }
    }
    return outputDiv;
  }
}
